import { MdsShortcutKeyCharacter } from "@/design-system/components/shortcut-key/types";
import styled from "@emotion/styled";
import { MDSText } from "@/mds";

interface MdsShortcutKeyProps {
  character: MdsShortcutKeyCharacter;
  inline?: boolean;
}

const shortcutKeyCharacterMap = {
  [MdsShortcutKeyCharacter.Command]: "⌘",
  [MdsShortcutKeyCharacter.C]: "C",
  [MdsShortcutKeyCharacter.Backslash]: "/",
};

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsShortcutKey = ({ character, inline = false }: MdsShortcutKeyProps) => {
  return (
    <ShortcutKeyWrapper $inline={inline}>
      <ShortcutKeyText>{shortcutKeyCharacterMap[character]}</ShortcutKeyText>
    </ShortcutKeyWrapper>
  );
};

const ShortcutKeyWrapper = styled.div<{ $inline?: boolean }>(({ theme, $inline }) => ({
  display: $inline ? "inline-flex" : "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "16px",
  width: "16px",
  padding: "1px 3px",
  borderRadius: theme.borderRadius.small,
  border: `1px solid ${theme.colors.border.onAccent}`,
}));

const ShortcutKeyText = styled(MDSText)(({ theme }) => ({
  fontSize: "11px",
  color: theme.colors.text.tertiary,
  lineHeight: theme.lineHeights.xxsmall,
}));
